<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";
import Img from "@/Components/Img.vue";
const route = inject("route");
const { t } = useI18n();
// Components
import Icon from "@/Components/Icon.vue";

// Icons
import calendar from "@i/calendar-pink.svg";
import user from "@i/user-icon.svg";
import thought from "@i/thought-icon.svg";
</script>
<template>
  <div class="section-container">
    <div class="grid md:grid-cols-2 gap-8 items-center">
      <!-- Left Content -->
      <div>
        <h2
          class="text-4xl md:text-5xl"
        >{{ $t('Onze ervaring en aanbod van professionals en oplossingen') }}</h2>

        <h3 class="mt-6 text-xl font-semibold">{{ $t('Onze Aanpak') }}</h3>

        <p
          class="mt-2 text-lg"
        >{{ $t('Onze werkwijze start met een grondige analyse van uw zorgvraag. Samen met u brengen we uitdagingen en oorzaken in kaart. Vervolgens werken we aan oplossingen die direct resultaat bieden en langdurige verbeteringen realiseren.') }}</p>

        <!-- Two Columns: Professionals & Oplossingen -->
        <div class="mt-6 grid md:grid-cols-2 gap-6">
          <div>
            <Icon :icon="user" class="w-14 mb-4" />
            <h3 class="text-xl font-semibold flex items-center">{{ $t('Professionals') }}</h3>
            <p
              class="mt-2 text-lg"
            >{{ $t('We beschikken over een uitgebreid netwerk van gekwalificeerde professionals met diverse ervaringen in de gehandicaptenzorg en de GGZ. We kunnen snel en efficiënt de juiste professionals vinden voor de specifieke behoeften van onze klanten.') }}</p>
          </div>

          <div>
            <Icon :icon="thought" class="w-14 mb-4" />
            <h3 class="text-xl font-semibold flex items-center">{{ $t('Oplossingen') }}</h3>
            <p
              class="mt-2 text-lg"
            >{{ $t('We bieden een breed scala aan oplossingen die aansluiten bij de specifieke behoeften van onze klanten. We kunnen helpen met de werving en selectie van personeel, het vinden van tijdelijke vervangingen, het organiseren van trainingen en het verbeteren van de kwaliteit van zorg.') }}</p>
          </div>
        </div>
      </div>

      <!-- Right Image -->
      <div class="flex justify-center">
        <img
          src="@/../img/home/experience-section.jpeg"
          alt="Professionals in Zorg"
          class="max-w-full rounded-lg shadow-md"
        />
      </div>
    </div>
  </div>
</template>